import React from "react";

import Select from "react-select";
import { useQuery } from "react-query";

import { getBranches } from "../../../../../MyApi/sb/branches";
import { getEmployes } from "../../../../../MyApi/sb/employes";

const SubHeaderFilter = ({
  t,
  branchId,
  setSbBranchId,
  setSbEmployeId,
  setDateTo,
  setDateFrom,
}) => {
  const page = 0;
  const EmployeQuery = useQuery(["getEmployes", page, branchId], () =>
    getEmployes(page, branchId)
  );
  const branchQuery = useQuery(["getbranches", page], () => getBranches(page));

  const employes = EmployeQuery.data?.data || [];
  const branches = branchQuery.data?.data || [];

  const handelEmployeChange = (selectedEmploye) => {
    const employId = selectedEmploye ? selectedEmploye.id : 0;
    setSbEmployeId(employId);
  };
  const handelBranchChange = (selectedBranch) => {
    const branchId = selectedBranch ? selectedBranch.id : 0;
    setSbBranchId(branchId);
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    const { name } = e.target;

    if (name === "Date from") {
      setDateFrom(value);
    }
    if (name === "Date to") {
      setDateTo(value);
    }
  };
  return (
    <div className="card">
      <div class="card-body">
        <div className="row">
          <div className="col-6 col-md">
            <label htmlFor="">{t("Branches")}</label>
            <Select
              type="text"
              name="branches"
              isClearable={true}
              onChange={handelBranchChange}
              options={branches}
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name}
              placeholder="search"
            />
          </div>
          <div className="col-6 col-md">
            <label htmlFor="">{t("Employes")}</label>
            <Select
              type="text"
              name="employes"
              isClearable={true}
              onChange={handelEmployeChange}
              options={employes}
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name_ar}
              placeholder="search"
            />
          </div>
          <div className="col-6 col-md">
            <label htmlFor="">{t("Date from")}</label>
            <input
              name="Date from"
              type="date"
              className="form-control"
              onChange={handleSearchChange}
            />
          </div>
          <div className="col-6 col-md">
            <label htmlFor="">{t("DateTo")}</label>
            <input
              name="Date to"
              type="date"
              className="form-control"
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubHeaderFilter;
